import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  CardMedia,
  IconButton,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddProduct({ open, onClose, setOpen }: ModalProps) {
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [type, setType] = useState<string>("0");
  const [category, setCategory] = useState<string>("0");
  const [variant, setVariant] = useState<string>("0");

  // Category Change
  const handleCategoryChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };

  // Type Change
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
    setVariant("0"); // reset variant when type changes
  };

  // Variant Change
  const handleVariantChange = (event: SelectChangeEvent) => {
    setVariant(event.target.value as string);
  };

  return (
    <Modal className="modal addType_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Product</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">
            <div className="gap_p">

              {/* Upload Image */}
              <div className="control_group">
                <label>Upload Image</label>

                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="Product" />
                      </figure>

                      <IconButton
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  </div>
                ) : (
                  <label className="upload_image no_radius" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg" }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = event.target.files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />

                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="placeholder" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="Upload" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              {/* Category */}
              <div className="control_group w_50">
                <label>Category</label>
                <Select fullWidth value={category} onChange={handleCategoryChange}>
                  <MenuItem value="0" disabled>
                    Select Category
                  </MenuItem>
                  <MenuItem value="smoothies">Smoothies</MenuItem>
                  <MenuItem value="beverages">Beverages</MenuItem>
                </Select>
              </div>

              {/* Name */}
              <div className="control_group w_50">
                <label>Name</label>
                <TextField fullWidth hiddenLabel placeholder="Enter Name" />
              </div>

              {/* Ingredients */}
              <div className="control_group">
                <label>Ingredients</label>
                <TextField fullWidth hiddenLabel placeholder="Enter Ingredients" />
              </div>

              {/* Description */}
              <div className="control_group">
                <label>Description</label>
                <TextField
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Description"
                  multiline
                />
              </div>

              {/* Type */}
              <div className="control_group w_50">
                <label>Type</label>
                <Select fullWidth value={type} onChange={handleTypeChange}>
                  <MenuItem value="0" disabled>
                    Select Type
                  </MenuItem>
                  <MenuItem value="size">Size</MenuItem>
                  <MenuItem value="variant">Variant</MenuItem>
                </Select>
              </div>

              {/* ================= SIZE SELECTED ================= */}
              {type === "size" && (
                <>
                  <div className="control_group w_50">
                    <label>Size</label>
                    <TextField fullWidth hiddenLabel placeholder="Enter Size" />
                  </div>

                  <div className="control_group w_50">
                    <label>Price</label>
                    <TextField fullWidth hiddenLabel placeholder="Enter Price" />
                  </div>
                </>
              )}

              {/* ================= VARIANT SELECTED ================= */}
              {type === "variant" && (
                <>
                  <div className="control_group w_50">
                    <label>Variant</label>
                    <Select fullWidth value={variant} onChange={handleVariantChange}>
                      <MenuItem value="0" disabled>
                        Choose Variant
                      </MenuItem>
                      <MenuItem value="single">Single Variant</MenuItem>
                      <MenuItem value="double">Double Variant</MenuItem>
                    </Select>
                  </div>

                  {/* Variant = Single */}
                  {variant === "single" && (
                    <div className="control_group w_50">
                      <label>Price</label>
                      <TextField fullWidth hiddenLabel placeholder="Enter Price" />
                    </div>
                  )}

                  {/* Variant = Double */}
                  {variant === "double" && (
                    <>
                      <div className="control_group w_50">
                        <label>Single Price</label>
                        <TextField fullWidth hiddenLabel placeholder="Enter price" />
                      </div>

                      <div className="control_group w_50">
                        <label>Double Price</label>
                        <TextField fullWidth hiddenLabel placeholder="Enter price" />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>

            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={() => setOpen(false)}>
                Add Product
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
